module.exports = __webpack_public_path__ + "img/ntk_nav_edit_g.1e43e6a1.svg";